import { FunctionComponent, useCallback } from 'react';

import {
    Menu,
    MenuButton,
    MenuList,
    MenuItemOption,
    MenuOptionGroup,
    MenuDivider,
} from '@chakra-ui/menu';
import { Button } from '@chakra-ui/react';
import { AvailableNetworks } from '../../redux/common/types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as cActions from '../../redux/common/actionCreators';
import { ChevronDownIcon } from '@chakra-ui/icons';

type NetworkSelectionProps = {
    network: AvailableNetworks;
    commonActions: any;
    hidden: boolean;
};

const NetworkSelection: FunctionComponent<NetworkSelectionProps> = ({
    network,
    commonActions,
    hidden,
}) => {
    const handleNetworkSelect = useCallback(
        network => {
            commonActions.networkSelect(network);
        },
        [commonActions],
    );
    return (
        <>
            {!hidden && (
                <Menu closeOnSelect={false} colorScheme='blue' id='network'>
                    <MenuButton
                        as={Button}
                        colorScheme='blue'
                        variant='outline'
                        bg='white'
                        rightIcon={<ChevronDownIcon />}
                        style={{ textTransform: 'capitalize' }}
                    >
                        {network}
                    </MenuButton>
                    <MenuList minWidth='240px'>
                        <MenuOptionGroup
                            value={network}
                            title='Seleziona la rete'
                            type='radio'
                            onChange={handleNetworkSelect}
                            // style={{ color: 'blue.500' }}
                            color='blue.500'
                        >
                            <MenuItemOption value='ropsten' color='blue.500'>
                                Ropsten
                            </MenuItemOption>
                            <MenuItemOption value='mainnet' color='blue.500'>
                                Mainnet
                            </MenuItemOption>
                        </MenuOptionGroup>
                        <MenuDivider />
                    </MenuList>
                </Menu>
            )}
        </>
    );
};

const mapDispatchToProps = (dispatch: any) => ({
    commonActions: bindActionCreators(cActions, dispatch),
});

const mapStateToProps = ({ common, wallet }: any) => {
    return {
        network: common.selectedNetwork,
        hidden: !wallet.wallet,
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(NetworkSelection);
